'use strict';

import React from 'react';
import PropTypes from 'prop-types';

// Tracking
import { trackEvent } from 'dibs-tracking';

class PaginationItem extends React.Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
    }

    onClick(event) {
        const { nextPage, numberOfPages, onPageChange } = this.props;

        trackEvent({
            action: 'pagination page number click',
            label: `${nextPage}/${numberOfPages}`,
            category: 'navigation',
        });

        if (onPageChange) {
            onPageChange(event, nextPage);
        }
    }

    render() {
        const { href, className, children, dataTn } = this.props;

        return (
            <a href={href} className={className} onClick={this.onClick} data-tn={dataTn}>
                {children}
            </a>
        );
    }
}

PaginationItem.propTypes = {
    children: PropTypes.node.isRequired,
    nextPage: PropTypes.number,
    numberOfPages: PropTypes.number,
    href: PropTypes.string,
    className: PropTypes.string,
    dataTn: PropTypes.string,
    onPageChange: PropTypes.func,
};

PaginationItem.defaultProps = {
    nextPage: 1,
    numberOfPages: 1,
    href: '#',
    className: '',
    dataTn: null,
};

export default PaginationItem;
